import { create } from 'zustand';
import { getCustomerPortalSession } from '../services/CustomerPortal';

const useCustomerAuthStore = create((set, get) => ({
    authenticated: false,
    customerId: null,
    initialized: false,
    checking: false,

    setAuthenticated: (customerId) => set({
        authenticated: true,
        customerId: Number(customerId) || null,
        initialized: true,
        checking: false,
    }),

    checkSession: async () => {
        if (get().checking) {
            return;
        }

        set({ checking: true });
        try {
            const session = await getCustomerPortalSession();
            set({
                authenticated: Boolean(session?.authenticated),
                customerId: Number(session?.customer_id) || null,
                initialized: true,
                checking: false,
            });
        } catch {
            set({ authenticated: false, customerId: null, initialized: true, checking: false });
        }
    },
}));

export default useCustomerAuthStore;